import Config from "../config/config.js";
export class Backend {
    constructor() {
        this._endpointPublicContent = "/api/anonymous/content";
        this._endpointAdminContent = "/api/admin/content";
        this._endpointPublicRegister = "/api/anonymous/register";
        this._endpointPublicVerify = "/api/anonymous/verify";
        this._endpointPublicReset = "/api/anonymous/reset";
        this._endpointPublicChangeEmail = "/api/anonymous/change/email";
        this._endpointLink = "/api/cards/link/";
        this._endpointAcceptReject = "/api/cards/accept/";
        this._endpointClip = "/api/cards/clip/";
        this._endpointClipDelivered = "/api/cards/clip/delivered";
        this._endpointClipReceived = "/api/cards/clip/received";
        this._endpointCards = "/api/cards";
        this._endpointCardStatus = "/api/cards/next";
        this._endpointCardArchive = "/api/cards/archive";
        this._endpointUser = "/api/user";
        this._endpointUserNameUpdate = "/api/user/name";
        this._endpointEmailUpdate = "/api/user/email";
        this._endpointUserPwUpdate = "/api/user/password";
        this._endpointExistingEmails = "/api/cards/emails/history";
        this._endpointWebpushSubscriptions = "/api/webpush/subscriptions";
        this._endpointWebpushSubscribe = "/api/webpush/subscribe";
        this._endpointWebpushUnsubscribe = "/api/webpush/unsubscribe";
        this._endpointWebpushSendMessage = "/api/webpush/all";
        this._host = Config.backendhost;
        this._oidc = Config.oidcurl;
    }
    static getInstance() {
        if (!Backend.instance) {
            Backend.instance = new Backend();
        }
        return Backend.instance;
    }
    fileExists(file) {
        return fetch(file, { method: "HEAD" }).then((res) => {
            if (res.ok) {
                return true;
            }
            else {
                return false;
            }
        });
    }
    fetchPublicContent(title) {
        return fetch(this._host + this._endpointPublicContent + "/" + title, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        }).then((response) => {
            if (response.ok) {
                return response.json();
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                throw e;
            }
            return this.errorConnection(e);
        });
    }
    fetchContentlist(access_token) {
        return fetch(this._host + this._endpointAdminContent, {
            method: "GET",
            headers: {
                Accept: "application/json",
                Authorization: "Bearer " + access_token,
            },
        }).then((response) => {
            if (response.ok) {
                return response.json();
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                throw e;
            }
            return this.errorConnection(e);
        });
    }
    putContent(access_token, content) {
        return fetch(this._host + this._endpointAdminContent, {
            method: "PUT",
            credentials: "include",
            headers: {
                Authorization: "Bearer " + access_token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(content),
        }).then((response) => {
            if (response.ok) {
                return response.json();
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                throw e;
            }
            return this.errorConnection(e);
        });
    }
    getLink(access_token, id, gid) {
        const headers = this.headerBuilder(access_token);
        return fetch(this._host + this._endpointLink + id + "/" + gid, {
            method: "GET",
            headers,
        }).then((response) => {
            if (response.ok) {
                return response.json();
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                throw e;
            }
            return this.errorConnection(e);
        });
    }
    getExistingEmails(access_token) {
        const headers = this.headerBuilder(access_token);
        return fetch(this._host + this._endpointExistingEmails, {
            method: "GET",
            headers,
        }).then((response) => {
            if (response.ok) {
                return response.json();
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                throw e;
            }
            return this.errorConnection(e);
        });
    }
    acceptOrRejectTheCard(access_token, id, gid, accept) {
        const headers = this.headerBuilder(access_token);
        return fetch(this._host + this._endpointAcceptReject + accept, {
            method: "PUT",
            headers,
            body: JSON.stringify({ id: id, gid: gid }),
        }).then((response) => {
            if (response.ok) {
                return response.json();
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                throw e;
            }
            return this.errorConnection(e);
        });
    }
    clipTheCard(access_token, id, gid, message) {
        const headers = this.headerBuilder(access_token);
        return fetch(this._host + this._endpointClip, {
            method: "POST",
            headers,
            body: JSON.stringify({ id: id, gid: gid, message: message }),
        }).then((response) => {
            if (response.ok) {
                return response.json();
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                throw e;
            }
            return this.errorConnection(e);
        });
    }
    clipTheCardDelivered(access_token, id, gid, clip) {
        const headers = this.headerBuilder(access_token);
        return fetch(this._host + this._endpointClipDelivered, {
            method: "PUT",
            headers,
            body: JSON.stringify({ id: id, gid: gid, size: clip }),
        }).then((response) => {
            if (response.ok) {
                return response.json();
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                throw e;
            }
            return this.errorConnection(e);
        });
    }
    clipTheCardReceived(access_token, id, gid, clip) {
        const headers = this.headerBuilder(access_token);
        return fetch(this._host + this._endpointClipReceived, {
            method: "PUT",
            headers,
            body: JSON.stringify({ id: id, gid: gid, size: clip }),
        }).then((response) => {
            if (response.ok) {
                return response.json();
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                throw e;
            }
            return this.errorConnection(e);
        });
    }
    registerUser(firstname, lastname, email) {
        return fetch(this._host + this._endpointPublicRegister, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ firstname: firstname, lastname: lastname, email: email }),
        }).then((response) => {
            if (response.ok) {
                return;
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                switch (e.response.status) {
                    case 406: throw new ResponseError(e, JSON.stringify({ "errorcode": 406, "errortext": "Email already registered" }));
                    default: throw e;
                }
            }
            return this.errorConnection(e);
        });
    }
    verifyUser(id, randomized) {
        return fetch(this._host + this._endpointPublicVerify + "/" + id + "/" + randomized, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        }).then((response) => {
            if (response.ok) {
                return response.json();
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                throw e;
            }
            return this.errorConnection(e);
        });
    }
    resetUser(email) {
        return fetch(this._host + this._endpointPublicReset, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ email: email }),
        }).then((response) => {
            if (response.ok) {
                return response.json();
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                throw e;
            }
            return this.errorConnection(e);
        });
    }
    resetUserVerification(id, randomized) {
        return fetch(this._host + this._endpointPublicReset + "/" + id + "/" + randomized, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        }).then((response) => {
            if (response.ok) {
                return response.json();
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                throw e;
            }
            return this.errorConnection(e);
        });
    }
    changeEmail(id, randomized) {
        return fetch(this._host + this._endpointPublicChangeEmail + "/" + id + "/" + randomized, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        }).then((response) => {
            if (response.ok) {
                return response.json();
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                throw e;
            }
            return this.errorConnection(e);
        });
    }
    oidcLogin(username, password) {
        return fetch(this._oidc + "/realms/ctc/protocol/openid-connect/token", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams({
                client_id: "frontend",
                scope: "openid",
                grant_type: "password",
                username: username,
                password: password,
            }),
        }).then(response => {
            if (response.ok) {
                return response.json();
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                switch (e.response.status) {
                    case 401: throw new ResponseError(e, JSON.stringify({ "errorcode": 401, "errortext": "Wrong email / password" }));
                    default: return this.errorUnhandled(e);
                }
            }
            return this.errorConnection(e);
        });
    }
    oidcRefresh(refreshToken) {
        return fetch(this._oidc + "/realms/ctc/protocol/openid-connect/token", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams({
                client_id: "frontend",
                scope: "openid",
                grant_type: "refresh_token",
                refresh_token: refreshToken,
            }),
        }).then((response) => {
            if (response.ok) {
                return response.json();
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                switch (e.response.status) {
                    case 502: throw new ResponseError(e, JSON.stringify({ "errorcode": 502, "errortext": "Problem renewing session, please logout and try again" }));
                    default: return this.errorUnhandled(e);
                }
            }
            return this.errorConnection(e);
        });
    }
    authenticatedUser(access_token) {
        return fetch(this._host + this._endpointUser, {
            method: "GET",
            headers: {
                Accept: "application/json",
                Authorization: "Bearer " + access_token,
            },
        }).then((response) => {
            if (response.ok) {
                return response.json();
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                throw e;
            }
            return this.errorConnection(e);
        });
    }
    putName(access_token, nameu) {
        return fetch(this._host + this._endpointUserNameUpdate, {
            method: "PUT",
            credentials: "include",
            headers: {
                Authorization: "Bearer " + access_token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(nameu),
        }).then((response) => {
            if (response.ok) {
                return;
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                throw e;
            }
            return this.errorConnection(e);
        });
    }
    putEmail(access_token, emailu) {
        return fetch(this._host + this._endpointEmailUpdate, {
            method: "PUT",
            credentials: "include",
            headers: {
                Authorization: "Bearer " + access_token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(emailu),
        }).then((response) => {
            if (response.ok) {
                return;
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                throw e;
            }
            return this.errorConnection(e);
        });
    }
    putPassword(access_token, pwu) {
        return fetch(this._host + this._endpointUserPwUpdate, {
            method: "PUT",
            credentials: "include",
            headers: {
                Authorization: "Bearer " + access_token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(pwu),
        }).then((response) => {
            if (response.ok) {
                return;
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                throw e;
            }
            return this.errorConnection(e);
        });
    }
    fetchCardlist(access_token, select) {
        return fetch(this._host + this._endpointCards + "/" + select, {
            method: "GET",
            headers: {
                Accept: "application/json",
                Authorization: "Bearer " + access_token,
            },
        }).then((response) => {
            if (response.ok) {
                return response.json();
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                throw e;
            }
            return this.errorConnection(e);
        });
    }
    postCard(access_token, card) {
        return fetch(this._host + this._endpointCards, {
            method: "POST",
            credentials: "include",
            headers: {
                Authorization: "Bearer " + access_token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(card),
        }).then((response) => {
            if (response.ok) {
                return response.json();
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                switch (e.response.status) {
                    case 400: throw new ResponseError(e, JSON.stringify({ "errorcode": 400, "errortext": this.backendErrorText(e.body, "Constraint violation") }));
                    default: throw e;
                }
            }
            return this.errorConnection(e);
        });
    }
    putCard(access_token, card) {
        return fetch(this._host + this._endpointCards, {
            method: "PUT",
            credentials: "include",
            headers: {
                Authorization: "Bearer " + access_token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(card),
        }).then((response) => {
            if (response.ok) {
                return response.json();
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                switch (e.response.status) {
                    case 400: throw new ResponseError(e, JSON.stringify({ "errorcode": 400, "errortext": this.backendErrorText(e.body, "Constraint violation") }));
                    default: throw e;
                }
            }
            return this.errorConnection(e);
        });
    }
    putStatus(access_token, card) {
        return fetch(this._host + this._endpointCardStatus, {
            method: "PUT",
            credentials: "include",
            headers: {
                Authorization: "Bearer " + access_token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(card),
        }).then((response) => {
            if (response.ok) {
                return response.json();
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                throw e;
            }
            return this.errorConnection(e);
        });
    }
    archiveReceivedCard(access_token, card) {
        return fetch(this._host + this._endpointCardArchive, {
            method: "PUT",
            credentials: "include",
            headers: {
                Authorization: "Bearer " + access_token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(card),
        }).then((response) => {
            if (response.ok) {
                return response.json();
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                throw e;
            }
            return this.errorConnection(e);
        });
    }
    postWebpushSubscription(access_token, data) {
        return fetch(this._host + this._endpointWebpushSubscribe, {
            method: "POST",
            credentials: "include",
            headers: {
                Authorization: "Bearer " + access_token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        }).then((response) => {
            if (response.ok) {
                return response.json();
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                throw e;
            }
            return this.errorConnection(e);
        });
    }
    postWebpushUnsubscription(access_token, data) {
        return fetch(this._host + this._endpointWebpushUnsubscribe, {
            method: "POST",
            credentials: "include",
            headers: {
                Authorization: "Bearer " + access_token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        }).then((response) => {
            if (response.ok) {
                return response.json();
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                throw e;
            }
            return this.errorConnection(e);
        });
    }
    postWebpushSendMessage(access_token, data) {
        return fetch(this._host + this._endpointWebpushSendMessage, {
            method: "POST",
            credentials: "include",
            headers: {
                Authorization: "Bearer " + access_token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        }).then((response) => {
            if (response.ok) {
                return response.json();
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                throw e;
            }
            return this.errorConnection(e);
        });
    }
    fetchWebpushsubscriptions(access_token) {
        return fetch(this._host + this._endpointWebpushSubscriptions, {
            method: "GET",
            headers: {
                Accept: "application/json",
                Authorization: "Bearer " + access_token,
            },
        }).then((response) => {
            if (response.ok) {
                return response.json();
            }
            return response.text().then(bodytext => { throw new ResponseError(response, bodytext); });
        }).catch((e) => {
            if (e.body) {
                throw e;
            }
            return this.errorConnection(e);
        });
    }
    headerBuilder(access_token) {
        let headers;
        if (access_token !== undefined) {
            headers = { Authorization: "Bearer " + access_token, "Content-Type": "application/json" };
        }
        else {
            headers = { "Content-Type": "application/json" };
        }
        return headers;
    }
    backendErrorText(bodytext, fallbacktext) {
        const body = JSON.parse(bodytext);
        if (body.violations[0]) {
            return body.violations[0].message;
        }
        return fallbacktext;
    }
    errorUnhandled(e) {
        throw new ResponseError(e, JSON.stringify({ "errorcode": 500, "errortext": "An unfortunate error occurred" }));
    }
    errorConnection(e) {
        throw new ResponseError(e, JSON.stringify({ "errorcode": 408, "errortext": "Connection issues" }));
    }
}
export class ResponseError extends Error {
    constructor(response, body) {
        super();
        this.response = response;
        this.body = body;
    }
}
//# sourceMappingURL=backend.service.js.map